import { CanceledError } from "axios";

// ---------------------------------------------------------------------------
// One-account-per-browser guard.
//
// Auth is the httpOnly 'sid' cookie, and the browser keeps only ONE per site —
// so if tab 1 is logged in as A and tab 2 logs in as B, tab 1's requests now
// silently go out as B while its screen still shows A's data (and A's ID held
// in component state). Any entry saved from tab 1 then lands on the wrong
// account.
//
// Each tab remembers which account it is showing (bound when the protected
// area mounts). If localStorage's account changes underneath it (login/logout
// in another tab), the tab is "stale": API calls are refused here and
// TabSessionGuard blocks the screen until the user reloads.
// ---------------------------------------------------------------------------
const IDENTITY_KEY = "PhoneNumber";

let tabIdentity = null;

export const getStoredIdentity = () => localStorage.getItem(IDENTITY_KEY);

export function bindTabIdentity() {
  tabIdentity = getStoredIdentity();
}

export function unbindTabIdentity() {
  tabIdentity = null;
}

export function isTabSessionStale() {
  return tabIdentity !== null && getStoredIdentity() !== tabIdentity;
}

// Axios request interceptor — registered on axiosInstance, plainAxios and the
// global axios (API origin only), so no call can leave a stale tab.
export function rejectIfTabSessionStale(config) {
  if (isTabSessionStale()) {
    throw new CanceledError(
      "Account changed in another tab — reload this tab to continue.",
    );
  }
  return config;
}
